import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { ApiRequest } from 'GlobalFunctions';

const monthNames = [
  '', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export default function BudgetCreate(props: any) {
  const { open, setOpen, onCreated } = props;
  const { enqueueSnackbar } = useSnackbar();

  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear();

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);
  const [businessDays, setBusinessDays] = useState(22);
  const [workedDays, setWorkedDays] = useState(0);
  const [saving, setSaving] = useState(false);

  const years = [currentYear - 1, currentYear, currentYear + 1];

  const handleCreate = async () => {
    setSaving(true);

    const body = new FormData();
    body.append('formValues', JSON.stringify({
      year,
      month,
      business_days: businessDays,
      worked_days: workedDays,
    }));

    await ApiRequest({
      url: "/budgets/create",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: body,
      setResponse: (response: any) => {
        if (response.status === 'success') {
          enqueueSnackbar(response.message, { variant: 'success' });
          onCreated(response.data.budget_id);
        } else {
          enqueueSnackbar(response.message, { variant: 'error' });
        }
        setSaving(false);
      },
    });
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Nuevo Presupuesto</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '8px' }}>
          <FormControl fullWidth>
            <InputLabel>Año</InputLabel>
            <Select
              value={year}
              label="Año"
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Mes</InputLabel>
            <Select
              value={month}
              label="Mes"
              onChange={(e) => setMonth(Number(e.target.value))}
            >
              {monthNames.slice(1).map((name, index) => (
                <MenuItem key={index + 1} value={index + 1}>{name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Días Laborables"
            type="number"
            fullWidth
            value={businessDays}
            onChange={(e) => setBusinessDays(Number(e.target.value))}
            inputProps={{ min: 0, max: 31 }}
          />

          <TextField
            label="Días Trabajados"
            type="number"
            fullWidth
            value={workedDays}
            onChange={(e) => setWorkedDays(Number(e.target.value))}
            inputProps={{ min: 0, max: 31 }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleCreate} variant="contained" disabled={saving}>
          {saving ? 'Creando...' : 'Crear Presupuesto'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
